module.exports = __webpack_public_path__ + "img/boxx-mini-white.6719acd7.svg";